/**
 * Realitation relocate header
 */

export const realisationRelocateHeader = () => {
  (function ($) {

    if ($('body').is('.page-node-type-realisations')) {
      // relocate header

      if($('#realitationHeader').length > 0) {
        let headerDetail = $('#realitationHeader').clone();
        $('#realitationHeader').remove();
        headerDetail.insertBefore('#block-breadcrumbs');
      }
      

      // remove header title
      if($('#block-thomaspiron-page-title').length > 0) {
        $('#block-thomaspiron-page-title').remove();
      }
      

      // Relocate social media
      if($('#block-bettersocialsharingbuttons').length > 0) {
        let socialMedia = $('#block-bettersocialsharingbuttons').clone();
        $('#block-bettersocialsharingbuttons').remove();
        socialMedia.insertBefore('#realisationContactForm');
      }
      
      if($('.realisation-status-project').length > 0) {
        let realisationProject = $('.realisation-status-project').clone();
        $('.realisation-status-project').remove();
        realisationProject.insertAfter('.breadcrumb');
      }
      

      $('.realisations__img-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
              dots: true,
              arrows: false,
            }
          },
          {
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1.25,
            }
          }
        ]
      })
    }


  })(jQuery);
}